import { Tooltip, type TooltipProps } from "antd";
import React, { memo, type ReactNode } from "react";

interface CustomTooltipProps extends TooltipProps {
  title?: ReactNode;
  children: ReactNode;
}

function CustomTooltip({
  title = "",
  children,
  ...rest
}: CustomTooltipProps) {
  return (
    <Tooltip title={title} {...rest}>
      {children}
    </Tooltip>
  );
}

export default memo(CustomTooltip);